<template>
    <div class="ranking-option-panel col position-relative">
        <v-row justify="start" class="options-panel">
            <v-col cols="12" class="d-flex justify-start ma-0 pa-0">
                <v-btn-toggle
                    v-model="rank"
                    tile
                    group
                    borderless
                    mandatory
                    dense
                    @change="changeRanking"
                >
                    <v-btn
                        value="school"
                        class="px-5 pb-3 mx-2 color-text"
                        :disabled="!ready"
                    >
                        {{ $t('ranking.my_school') }}
                    </v-btn>
                    <v-btn
                        value="global"
                        class="px-8 pb-3 mx-2 color-text"
                        :disabled="!ready"
                    >
                        {{ $t('ranking.global') }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
    props: {
        ready: { type: Boolean, default: true },
    },
    computed: {
        ...mapState({
            rankingMode: (state) => state.rankingMode,
        }),
    },
    data() {
        return {
            rank: 'school',
        }
    },
    mounted() {
        this.rank = this.rankingMode
    },
    methods: {
        ...mapActions(['setRankingMode']),
        changeRanking() {
            this.setRankingMode(this.rank)
        },
    },
}
</script>
<style lang="scss" scoped>
.v-btn-toggle {
    & > .v-btn.v-btn--active {
        color: #323A46;
        font-weight: 600;
        position: relative;
        transition: transform 0.3s;
        &::after{
            content: '';
            height: 6px;
            background: #7764CA;
            border-radius: 3px;
            box-shadow: 0px 0px 2px 0px #7764CA80;
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            z-index: 1;
        }
    }
    & > .v-btn{
        color: #64748B;
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: 0;
    }
}

.options-panel{
    position: relative;
    &::after{
        content: '';
        border-bottom: 3px solid #eeecf8;
        display: block;
        width: 100%;
        position: absolute;
        bottom: 5px;
        left: 0;
        z-index: 0;
    }
}
.v-btn:before {
    background-color: white;
}
.v-btn {
    text-transform: none;
}
</style>
